import { Maybe } from '@noshiro/ts-utils';
import { InitializedSyncChildObservableClass } from '../class';
export const withInitialValue = (initialValue) => (parentObservable) => new WithInitialValueObservableClass(parentObservable, initialValue);
class WithInitialValueObservableClass extends InitializedSyncChildObservableClass {
    constructor(parentObservable, initialValue) {
        super({
            parents: [parentObservable],
            type: 'withInitialValue',
            currentValueInit: Maybe.some(initialValue),
        });
    }
    tryUpdate(token) {
        const par = this.parents[0];
        if (par.token !== token)
            return; // skip update
        if (Maybe.isNone(par.currentValue))
            return; // skip update
        this.setNext(par.currentValue.value, token);
    }
}
